import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/developer/[slug]/components/DeveloperInfo.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/developer/[slug]/components/DeveloperProjectGridList.jsx");
